import styled from "styled-components";

export const ProductViewContainer = styled.div`
  max-width: 1440px;
  padding: 0 20px;
  width: 100%;
  height: 100%;
  position: relative;
  margin: 0 auto;
  .nav {
    display: flex;
    margin-left: auto;
    background: transparent;
    border: none;
  }
  .product {
    display: flex;
    align-items: center;
    gap: 100px;
    margin-top: 20px;
  }
  .images {
    width: calc(40% - 50px);
    .thumbsSwiper {
      margin-top: 20px;
    }
    .thumb-img {
      border: 1px solid #ddd;
      cursor: pointer;
    }
    .image {
      width: 100%;
      height: 100%;
      border: 1px solid #ddd;
      padding: 20px;
      cursor: pointer;
    }
    img {
      width: 100%;
      height: 100%;
      aspect-ratio: 1;
      object-fit: contain;
    }
  }
  .info {
    width: calc(60% - 50px);
    .name {
      font-size: 30px;
      font-weight: 700;
    }
    .rating {
      display: flex;
      align-items: center;
      gap: 10px;
      margin: 20px 0;
      color: #999;
      svg {
        color: #ffe082;
        margin: 0;
      }
      button {
        color: #999;
        font-size: smaller;
        background: transparent;
        border-bottom: 1px solid #999;
      }
    }
    .price {
      display: flex;
      align-items: center;
      gap: 10px;
      span {
        color: #999;
        text-decoration: line-through;
      }
      strong {
        font-weight: 700;
      }
    }
    .productInfo .price {
      display: flex;
      align-items: center;
      gap: 10px;
      border-bottom: 1px solid #bbb;
      margin-bottom: 20px;
      padding-bottom: 20px;
      strong {
        font-size: 30px;
      }
    }
    .label {
      margin: 20px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .cont {
        display: flex;
        justify-content: flex-end;
        gap: 10px;
      }
    }
    .productCount {
      border: 1px solid #bbb;
      color: #777;
      padding: 20px;
      .cont {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 10px;
      }
      .selectCount {
        display: flex;
        width: 120px;
        align-items: center;
        height: 30px;
        text-align: center;
        border: 1px solid #bbb;
        span {
          width: 60px;
          color: #000;
        }
        button {
          width: 30px;
          background: transparent;
          color: #bbb;
          svg {
            display: block;
            margin: auto;
          }
        }
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
    .options {
      margin-top: 20px;
      /* border: 1px solid #bbb;
      color: #777;
      padding: 20px;
      margin-top: 20px; */
      li {
        color: #777;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &:last-child {
          margin-bottom: 0;
        }
        select {
          width: 100%;
          border: 1px solid #bbb;
          color: #777;
          padding: 10px 0px 10px 20px;
          &:focus {
            border: 1px solid #bbb !important;
            box-shadow: none;
            outline: none;
          }
        }
      }
    }
    .actions {
      margin-top: 50px;
      display: flex;
      gap: 20px;
      button {
        width: calc(50% - 10px);
        height: 50px;
        border: 1px solid #000;
        background: transparent;
        &:last-child {
          background: #000;
          color: #fff;
        }
      }
    }
  }
  .details {
    .image {
      text-align: center;
    }
    img {
      max-width: 100%;
    }
  }
  &.theme-2 {
    &.theme-2 {
      max-width: 1240px;
    }
    .images .image {
      border-color: #bbb;
      border-radius: 20px;
    }
    .name {
      font-size: xxx-large;
    }
    .info {
      ul li {
        border-radius: 10px;
      }
      .actions {
        margin-top: 50px;
        display: flex;
        gap: 20px;
        button {
          border-radius: 10px;
          width: calc(50% - 10px);
          height: 50px;
          border: 1px solid #333;
          background: transparent;
          color: #333;
          &:last-child {
            background: #333;
            color: #fff;
          }
        }
      }
    }
  }
  &.theme-4 {
    .rating {
      display: none;
    }
    .images .image,
    .images .thumb-img {
      border-color: #bbb;
    }
    .name {
      font-weight: 900;
      margin-bottom: 20px;
    }
    .amount strong {
      color: #00aeef;
    }
    ul li .price strong {
      color: #000;
    }
    .product .info .actions button {
      width: 100%;
    }
  }
  @media screen and (max-width: 1050px) {
    .product {
      gap: 50px;
      align-items: flex-start;
      .images,
      .info {
        width: calc(50% - 25px);
      }
      .info {
        .name,
        .productInfo .price strong {
          font-size: 24px;
        }
        ul {
          margin: 20px 0;
        }
        .actions {
          margin-top: 30px;
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    .product {
      gap: 20px;
      flex-direction: column;
      .images,
      .info {
        width: 100%;
      }
      .info {
        .name,
        .productInfo .price strong {
          font-size: 18px;
        }
        .productInfo .price {
          margin-bottom: 10px;
          padding-bottom: 10px;
        }
        ul,
        .rating {
          margin: 10px 0;
        }
        ul li {
          padding: 10px;
        }
        .actions {
          margin-top: 20px;
          gap: 10px;
          button {
            width: calc(50% - 5px);
            height: 40px;
            font-size: 14px;
          }
        }
      }
    }

    &.theme-4 {
      .product .info .name {
        margin-bottom: 10px;
      }
    }
  }
`;
